interface TitleListProps {
    title: string
}

const TitleList = ({ title = '' }: TitleListProps) => {
    return (
        <div className='w-full px-[min(30px,2.8vw)] py-[5px] bg-primaryWeb'>
            <h5 className='text-customWhite text-fs-mid14 font-bold leading-lh-nor14'>{title}</h5>
        </div>
    );
};

export default TitleList;
